import WeeklyPayment from "../views/payments/week-billing.vue";
const routes = [
  {
    path: "/week/:month/:week",
    component: WeeklyPayment,
  },
];

export default routes;
